import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import $ from "jquery";
import {FormattedMessage} from "react-intl";

import Analytics from "../../../../analytics";
import ActionTypes from "../../../../misc/actionTypes";
import LookFeatureRemoveButton from "../../../look/lookNavigation/lookMain/lookFeatureRemoveButton";
import {getCurrentLayout} from "../../../appLayout";
import {disableFeature} from "../../../look/lookNavigation/lookFunctions2";
import {updateCanvasCount} from "../../../../actions/actionFunctions";

class BodyPanelRadio extends Component {

  static propTypes = {
    activeSubPart: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
    quotingTool: PropTypes.bool,
    refreshItems: PropTypes.func,
  };

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.updateDisableFeatureGroupRadio && !this.props.updateDisableFeatureGroupRadio) {
  //     this.forceUpdate();
  //   }
  // }

  radioClick = async () => {
    const activeSubPart = this.props.activeSubPart;
    Analytics.sendClickEvent('disable-toggle-' + activeSubPart.partId);
    const layout = getCurrentLayout();
    if (!activeSubPart.disabled && activeSubPart.activeFeature && layout.isNewLayout) {
      await disableFeature(activeSubPart.activeFeature)
    } else {
      activeSubPart.disabled = !activeSubPart.disabled;
      activeSubPart.disabledClick();
      activeSubPart.updateLocalStorage();
    }
    $(window).trigger(ActionTypes.CHANGE_LAYOUT); // update canvas
    if (this.props.refreshItems) {
      this.props.refreshItems();// update navigation (non compatible)
    }
    this.forceUpdate();
    this.props.updateCanvasCount();
    setTimeout(() => {
      this.forceUpdate(); // for slow udpates
    }, 0)
  };

  render() {
    const activeSubPart = this.props.activeSubPart;
    const cabinetsPartIds = ["top_cabinet", "bottom_cabinet", "center_island_cabinet"];
    const isCabinet = activeSubPart && cabinetsPartIds.includes(activeSubPart.partId);
    const countertopPartIds = ["countertop", "backsplash", "center_island_countertop"];
    const isCountertop = activeSubPart && countertopPartIds.includes(activeSubPart.partId);

    if (this.props.quotingTool) {
      return (
        <div className="ui-radio-block">
          <span className="ui-radio-label"><FormattedMessage id="radioButtonDisableFeatueGroup"/></span>
          <button className={"ui-radio ui-radio--small" + (activeSubPart && !activeSubPart.disabled ? " ui-radio--checked" : "")}
                  onClick={this.radioClick}>
            <span className="ui-radio-circle"/>
            <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
            <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
          </button>
        </div>
      )
    }


    const layout = getCurrentLayout();
    if (layout.isNewLayout) {
      if (!activeSubPart || !activeSubPart.activeFeature) {
        return null
      }
      const text = this.props.isMobile && activeSubPart.partId === "center_island_cabinet" && this.props.windowWidth < 800
        ? "radioButton.on"
        : "radioButtonDisableFeatueGroup1";
      return <LookFeatureRemoveButton lookFeature={activeSubPart.activeFeature}
                                      refreshItems={this.props.refreshItems}
                                      text={text}
                                      isToggle={true}/>
    }

    return (
      <button className={"ui-radio"
      + (activeSubPart && !activeSubPart.disabled ? " ui-radio--checked" : "")
      + (!this.props.isMobile || isCabinet || isCountertop ? " ui-radio--small" : "")}
              onClick={this.radioClick}>
        <span className="ui-radio-circle"/>
        <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
        <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
      </button>
    )
  }
}

const mapStateToProps = (store) => {
  const {updateDisableFeatureGroupRadio} = store.navigationState;
  const {windowWidth} = store.serverState;
  const {canvasCount} = store.bathroomVisualizerState; // to update component when feature is changed

  return {
    updateDisableFeatureGroupRadio,
    windowWidth,
    canvasCount,
  }
}

const mapDispatchToProps = {
  updateCanvasCount,
};

export default connect(mapStateToProps, mapDispatchToProps)(BodyPanelRadio);

